import { useState, useEffect, type FC } from 'react';
import type { BasicCollectionInformation } from '@starly/starly-types';
import User from 'components/User';
import OtherCollections from 'views/Sale/components/OtherCollections/OtherCollections';
import CollectedBlock from '../../../Collection/components/CollectedBlock';

import { type IUserProps } from './types';

import { UserWrapper, CollectionUserWrapper } from './styled';

const CollectionUser: FC<IUserProps> = ({ user, isOwnProfile, collectionId }) => {
  const [createdCollections, setCreatedCollections] = useState<BasicCollectionInformation[]>([]);

  useEffect(() => {
    setCreatedCollections((user?.createdCollections || []).filter((v) => v.id !== collectionId));
  }, [user?.createdCollections, collectionId]);

  return (
    <CollectionUserWrapper>
      <UserWrapper>
        <User
          id={user.id}
          username={user.username}
          name={user.name}
          bio={user.bio}
          avatar={user?.avatar}
          instagram={user.connections?.instagram?.username}
          youtube={user.connections?.youtube?.channel_id}
          twitter={user.connections?.twitter?.screen_name}
          url={user.url}
          isCreatedCollections
          isCollectedCollection
          isOwnProfile={isOwnProfile}
        />
      </UserWrapper>
      {Boolean(createdCollections.length) && (
        <OtherCollections collections={createdCollections} name={user?.name} username={user.username} />
      )}
      <CollectedBlock key={user.id} user={user} />
    </CollectionUserWrapper>
  );
};

export default CollectionUser;
